module.exports = __webpack_public_path__ + "img/Apple.0c2b67dd.svg";